import * as React from 'react';
import { BehaviorSubject } from 'rxjs';

export interface AppAlert {
  level:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark';
  message: string;
  dismissible?: boolean;
}

export class AlertService {
  public alertsList: AppAlert[] = [];
  public alertsListSubject: BehaviorSubject<AppAlert[]> = new BehaviorSubject<
    AppAlert[]
  >(this.alertsList);

  public addAlertToList(alert: AppAlert): void {
    this.alertsList.push(alert);
    this.alertsListSubject.next(this.alertsList);
  }

  public removeAlertFromList(index: number): void {
    this.alertsList.splice(index, 1);
    this.alertsListSubject.next(this.alertsList);
  }
}

export const ALERT_SERVICE = React.createContext<AlertService>(null!);

export function AlertServiceProvider({ children }: React.PropsWithChildren) {
  const [alertService] = React.useState(() => new AlertService());

  return (
    <ALERT_SERVICE.Provider value={alertService}>
      {children}
    </ALERT_SERVICE.Provider>
  );
}

export function useAlertService() {
  return React.useContext(ALERT_SERVICE);
}
